<template>
  <modal ref="modal" title="Pedido" :overflow="true" @voltar="closeModal()">
    <loading v-if="load"/>
    <div v-else-if="pedido">
      <div class="container-fluid mt-3 pb-3" v-show="menu === 1">
        <h5 class="mb-2 text-center">{{pedido.nome_fantasia}}</h5>
        <div class="p-2 mb-3 border rounded-lg bg-light text-center">
          <div class="font-weight-bold">
            #{{pedido.id_contador}}
          </div>
          <div class="tamanho-2">
            {{pedido.data_pedido}} |
            <span class="text-nowrap" v-if="!pedido.data_agendamento && pedido.previsao">
                Previsão {{pedido.tipo_pedido === '1' ? '(entrega)' : '(retirada)'}}: <b>{{getPrevisao()}}</b>
              </span>
          </div>
          <div class="tamanho-2" v-if="pedido.nolocal">Local: {{ pedido.nolocal }}</div>
        </div>
        <div class="text-center" v-if="pedido.data_agendamento">
          <div class="font-weight-bold">**PEDIDO AGENDADO**</div>
          <div class="small">{{pedido.data_agendamento}}</div>
          <hr>
        </div>
        <aviso-informativo variante="amarelo" class="small mb-3" v-if="!pedido.produtos.length">
          Os produtos deste pedido não estão mais disponíveis.
        </aviso-informativo>
        <div v-else>
          <div class="row produtos" v-for="i in pedido.produtos">
            <div class="col">
              <div class="mb-0 tamanho-1"><b>{{i.quantidade}}x</b> {{i.produto.nome_produto}}</div>
              <div v-for="d in i.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</div>
              <div v-for="d in i.adicionais" class="m-0 pl-2 tamanho-2">
                <b v-show="d.qtd > 1">{{d.qtd}}x</b> + {{d.nome_produto}}
                <span v-show="d.valor > 0">{{(d.qtd * d.valor) | valor}}</span>
              </div>
              <div class="m-0 pl-2 tamanho-2" v-show="i.observacao">
                <b>Obs:</b> {{i.observacao}}
              </div>
            </div>
            <div class="col-5 text-right tamanho-1">
              <span v-if="i.valor > 0">{{i.quantidade * i.valor | valor}}</span>
              <span class="badge badge-success" v-else>Grátis</span>
            </div>
          </div>
          <hr>
        </div>
        <div v-if="pedido.origin !== '4'">
          <div class="row" v-if="pedido.id_pagamento !== '5'">
            <div class="col">Pagamento:</div>
            <div class="col-5 align-self-center text-right">
              {{pedido.nome_pagamento}}
            </div>
          </div>
          <div class="row" v-show="pedido.troco > 0">
            <div class="col">
              Troco p/:
            </div>
            <div class="col-5 align-self-center text-right">
              {{pedido.troco | valor}}
            </div>
          </div>
          <div class="row">
            <div class="col">
              Subtotal:
            </div>
            <div class="col-4 align-self-center text-right">
              {{(parseFloat(pedido.valor_total) + parseFloat(pedido.valor_desconto) - parseFloat(pedido.valor_frete)) - parseFloat(pedido.valor_taxa ? pedido.valor_taxa : 0) | valor}}
            </div>
          </div>
          <div class="row" v-show="pedido.valor_desconto > 0">
            <div class="col">
              Desconto:
            </div>
            <div class="col-4 align-self-center text-right">
              {{pedido.valor_desconto | valor}}
            </div>
          </div>
          <div class="row" v-show="parseInt(pedido.tipo_pedido) === 1">
            <div class="col">
              Entrega:
            </div>
            <div class="col-4 align-self-center text-right">
              {{pedido.valor_frete | valor}}
            </div>
          </div>
          <div class="row" v-show="pedido.valor_taxa && pedido.valor_taxa !== '0'">
            <div class="col">
              {{pedido.valor_taxa > 0 ? 'Taxa' : 'Desconto'}} Pagamento
            </div>
            <div class="col-4 align-self-center text-right">
              {{pedido.valor_taxa | valor}}
            </div>
          </div>
          <div class="row font-weight-bold">
            <div class="col-4">
              Total:
            </div>
            <div class="col-8 align-self-center text-right h6">
              {{pedido.valor_total | valor}}
            </div>
          </div>
        </div>
        <div class="p-2 mb-2 border rounded-lg bg-light" v-if="pedido.obs_pedido">
          <div class="small font-weight-bold">Observação do pedido</div>
          {{ pedido.obs_pedido }}
        </div>
      </div>
      <form @submit.prevent="enviarAvaliacao()" v-show="menu === 2">
        <div class="container-fluid container-endereco text-center">
          <div class="p-2 border rounded-lg bg-light mb-3">
            <h6 class="mb-1 font-weight-bold">Pedido: {{pedido.id_contador}}</h6>
            <div class="small">Data: {{pedido.data_pedido}}</div>
          </div>
          <aviso-informativo variante="amarelo" class="mb-3" v-show="pedido.dias_pedido > 15">O prazo para avaliar este pedido já se encerrou.</aviso-informativo>
          <div class="form-group my-4">
            <h6 class="font-weight-bold mb-1">O que você achou do pedido?</h6>
            <p class="small">Escolha de 1 a 5 estrelas para avaliar</p>
            <div class="mb-1">
              <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 1 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(1)"></i></a>
              <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 2 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(2)"></i></a>
              <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 3 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(3)"></i></a>
              <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer mr-2" :class="pedido.nota < 4 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(4)"></i></a>
              <a href="javascript:" class="text-warning"><i class="fa fa-3x pointer" :class="pedido.nota < 5 ? 'fa-star-o' : 'fa-star'" @click="toggleNota(5)"></i></a>
            </div>
            <div class="small" v-if="pedido.nota > 0">{{ pedido.nota | nota }}</div>
            <div class="d-flex justify-content-between small mx-auto" style="max-width: 260px" v-else>
              <span>Ruim</span>
              <span>Excelente</span>
            </div>
          </div>
          <div class="form-group" v-show="pedido.nota">
            <h6 class="font-weight-bold mb-0" v-if="pedido.nota < 5 && pedido.nota > 0">O que podemos melhorar?</h6>
            <h6 class="font-weight-bold mb-0" v-else>Do que você gostou?</h6>
            <div v-if="pedido.dias_pedido <= 15">
              <label class="small mb-0">Digite no mínimo 10 caracteres</label>
              <textarea class="form-control mb-1 mt-2" id="comentario" placeholder="Eu achei que meu pedido.." v-model="pedido.comentario" rows="7" style="resize: none" minlength="10" maxlength="300" :required="pedido.nota !== 5"></textarea>
              <div class="small text-right">({{ (pedido.comentario || "").length }} / 300)</div>
            </div>
            <textarea class="form-control mt-3" rows="6" style="resize: none" disabled v-else>{{ pedido.comentario }}</textarea>
          </div>
        </div>
        <div class="fixed-bottom bg-white border-top btn-avancar fixed-container">
          <div class="p-3">
            <button type="submit" class="btn btn-primary btn-block btn-bottom" :disabled="!pedido.nota || loadAvaliacao || pedido.dias_pedido > 15">
              <span v-if="loadAvaliacao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-else>Enviar avaliação</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import AvisoInformativo from "./AvisoInformativo";
  import Modal from "./Modal.vue";
  import Loading from "./Loading.vue";

  export default {
    name: "ModalPedido",
    components: {AvisoInformativo, Loading, Modal},
    props: ['pedidos'],

    data() {
      return {
        url: '',
        load: false,
        pedido: null,
        opened: false,
        token: localStorage.getItem('token'),
        loadAvaliacao: false,
        menu: 1
      }
    },

    methods: {
      closeModal() {
        this.opened = false;
        this.$refs.modal.closeModal();
      },

      openModal(id, avaliar) {
        this.menu = 1;
        this.pedido = null;
        this.opened = true;
        this.$refs.modal.openModal();
        this.buscarPedidoId(id, avaliar);
      },

      buscarPedidoId(id, avaliar) {
        this.load = true;
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.get(url + this.token + '/pedido?id_pedido=' + id)
          .then(response => {
            this.load = false;

            if (response.data && response.data.id_pedido) {
              this.pedido = response.data;

              if (avaliar && this.pedido.status === '4') {
                this.menu = 2;
                this.pedido.nota = parseInt(this.pedido.nota || '0');
              }

            } else {
              this.closeModal();
              this.$swal("Pedido não encontrado!");
            }

          }, res => {
            this.load = false;
          });
      },

      toggleNota(n) {
        if (parseInt(this.pedido.dias_pedido || '100') <= 15) {
          this.pedido.nota = n;
        }
      },

      enviarAvaliacao() {
        if ((this.pedido.nota !== 5 || this.pedido.comentario) && (!this.pedido.comentario || this.pedido.comentario.length < 10 || this.pedido.comentario.length > 300)) {
          this.$swal('Sua avaliação precisa ter de 10 a 300 caracteres').then(() => {
            this.$helpers.focusrElement('comentario');
          });

          return;
        }

        this.loadAvaliacao = true;
        const url = this.$helpers.base_url(this, this.empresa);
        const dados = { id_pedido: this.pedido.id_pedido, nota: this.pedido.nota, comentario: this.pedido.comentario }
        this.$http.post(url + this.token + "/avaliacao", dados)
          .then(res => {
            this.loadAvaliacao = false;

            if (res.data.success) {
              this.closeModal();
              this.$emit('atualizar');
              this.$swal("Pedido avaliado com sucesso!");

            } else {
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            }

          }, res => {
            this.loadAvaliacao = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      getPrevisao() {
        if (this.pedido) {
          return this.empresa.unidade_tempo !== '3' ? this.pedido.previsao.slice(-5) : `${this.pedido.previsao.substring(0, 10)}`;
        }
      },
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      }
    },

    filters: {
      tipo_pedido(pedido) {
        switch (pedido.tipo_pedido) {
          case '1':
            return "Entregar";
          case '2':
            return "Retirar no Local";
          case '3':
            return "Consumir no Local";
        }
      },

      nota(n) {
        switch (n) {
          case 1: return 'Muito ruim';
          case 2: return 'Abaixo do esperado';
          case 3: return 'Razoável';
          case 4: return 'Muito bom';
          case 5: return 'Excelente!';
        }
      }
    }
  }
</script>

<style scoped>
.container-endereco {
  overflow: auto;
  height: auto;
  padding-top: 22px;
  padding-bottom: 84px;
}

.produtos {
  padding-top: 4px;
}

.produtos:first-child {
  padding-top: 0;
}

@media (min-width: 768px) {
  .btn-avancar {
    position:static;
    padding-right: 15px;
    padding-left: 15px;
  }

  .container-endereco {
    padding-top: 18px;
    padding-bottom: 0;
    height: calc(80vh - 142px);
  }
}
</style>
